import { GpsCoordinates, PhotoCategory, Sensor } from '../types';

type GeoPoint = {
  coordinates: GpsCoordinates;
  type: string;
};

type SensorCoordinates = {
  gpsPoint?: GeoPoint | null;
  installPoint?: GeoPoint | null;
};

type ZipImage = {
  date: string;
  title: string;
  url: string;
};

export const getSensorCoordinates = ({ gpsPoint, installPoint }: SensorCoordinates): GpsCoordinates | [] => {
  return gpsPoint ? gpsPoint.coordinates : installPoint ? installPoint.coordinates : [];
};

export const getSensorImagesForZip = (
  data: Sensor[] = [],
): Record<PhotoCategory, ZipImage[]> | null => {
  if (!data.length) return null;

  const titleMap: Record<PhotoCategory, string> = { ndvi: 'ndvi', day: 'rgb_day', night: 'rgb_night' };
  const result: Record<PhotoCategory, ZipImage[]> = { ndvi: [], day: [], night: [] };

  for (const obj of data) {
    for (const key of Object.keys(titleMap) as PhotoCategory[]) {
      const photos = obj.photos[key];
      if (!photos?.length) continue;

      for (const item of photos) {
        result[key].push({
          date: `${obj.date}_${item.taken_at}`,
          title: titleMap[key],
          url: item.url,
        });
      }
    }
  }

  return result.ndvi.length || result.day.length || result.night.length ? result : null;
};
